<template>
  <div>
    <banner-component></banner-component>
    <article class="container mx-auto flex justify-center mt-12">
      <!-- Introduction text -->
      <section
        class="rounded lg:w-2/4 w-4/5 lg:h-72 flex items-center text-center flex-col subpixel-antialiased"
      >
        <h1 class="text-gray-700 font-bold text-2xl my-4">Beste klanten</h1>
        <h3 class="text-gray text-md">
          Flavours is de engelse vertaling van het woord “smaken”. En smaken verschillen.
          <p>
            Sommige mensen houden van een zoutje, anderen hebben het dan weer graag pikant en
            sommigen hebben een voorkeur voor zoet. No problemo! Wij hebben vast wel een smaak in
            huis die bij u past. Grote honger, kleine honger of gewoon even zin in koffie of ander
            lekkers, spring zeker even binnen.
          </p>
        </h3>
        <!-- <h1 class="text-gray-700 font-bold text-4xl my-4">Flavours met vakantie</h1>
        <h3 class="text-gray text-md font-bold my-2">
          <p>Beste Klanten</p>
          <div>
            <div>Wij gaan er even tussenuit om onze batterijen weer op te laden.</div>
            <div>&nbsp;</div>
            <div>
              Wij zullen gesloten zijn van&nbsp;<span style="text-decoration: underline"
                ><strong>zaterdag 6 september</strong> tot en met
                <strong>maandag 22 september</strong></span
              >
            </div>
            <div>&nbsp;</div>
          </div>
          <div>
            <div>
              We staan opnieuw voor u klaar vanaf <strong>dinsdag 23 september</strong> om 8u
            </div>
            <div>&nbsp;</div>
            <div>Tot binnenkort...</div>
          </div>
        </h3>-->
        <h3 class="text-gray text-md mt-6">Tot binnenkort!</h3>
      </section>
    </article>

    <article
      class="container mx-auto flex lg:justify-around justify-center items-center lg:flex-row flex-col lg:mt-0 mt-12 mb-6"
    >
      <!-- Openingsuren -->
      <info-card-component class="mb-6 md:mb-0">
        <template v-slot:icon>
          <fa :icon="['fas', 'calendar-alt']"></fa>
        </template>
        <template v-slot:content>
          <h2 class="font-bold text-gray-700 my-2 text-md">Openingsuren</h2>
          <div class="flex flex-col text-sm">
            <p>Maandag &#45; Vrijdag: 08:00 &#45; 15:00</p>
            <p>Zaterdag: 09:00 &#45; 15:00</p>
          </div>

          <div class="mt-2 text-sm">
            <p>Zondag & feestdagen gesloten !</p>
          </div>
        </template>
      </info-card-component>

      <!-- Service -->
      <info-card-component class="mb-6 md:mb-0">
        <template v-slot:icon>
          <fa :icon="['fas', 'mobile-alt']"></fa>
        </template>
        <template v-slot:content>
          <h2 class="font-bold text-gray-700 my-2 text-md">Service</h2>
          <div class="flex flex-col">
            <p class="md:text-sm text-xs">Vermijd wachttijden, bestel op voorhand.</p>
            <p class="md:text-sm text-xs">
              Bestellingen vóór 10u30 kunnen op het gewenste uur worden afgehaald.
            </p>
          </div>
          <div class="mt-2">
            <p class="md:text-sm text-xs">Bestellen kan via telefoon (03 298 88 13)</p>
          </div>
        </template>
      </info-card-component>

      <!-- Klachten -->
      <info-card-component class="mb-6 md:mb-0">
        <template v-slot:icon>
          <fa :icon="['fas', 'circle-exclamation']"></fa>
        </template>
        <template v-slot:content>
          <h2 class="font-bold text-gray-700 my-2 text-md">Klachten</h2>
          <div class="flex flex-col">
            <p class="text-sm">Heeft u een klacht of een opmerking?</p>
            <p class="text-sm">Aarzel dan niet ons te contacteren!</p>
          </div>
        </template>
      </info-card-component>
    </article>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BannerComponent from '@/components/home/Banner.component.vue';
import InfoCardComponent from '@/components/home/Info-card.component.vue';

export default defineComponent({
  name: 'HomePage',
  components: { BannerComponent, InfoCardComponent },
});
</script>
